<template>
  <div class="tab-layout">
    <div v-if="recordList.length" class="match-player-record">
      <table>
        <thead>
        <tr>
          <th v-for="(item, index) in headList" :key="index"
              :class="{wd08: item === '위치' || item.includes('교체'), sticky: item === '배번' || item === '이름'}">
            {{item}}
          </th>
        </tr>
        </thead>
        <tbody v-if="recordList.length">
        <tr v-for="(item, index) in recordList" :key="index">
          <td class="point">{{item.player_no}}</td>
          <td ref="sticky" class="point left sticky" style="white-space: nowrap;">
            <img :src="item.player_img" alt="">
            {{item.name}}
          </td>
          <td>{{item.Work_Des}}</td>
          <td>{{item.Change_i_Des ? item.Change_i_Des : '-'}}</td>
          <td>{{item.Change_o_Des ? item.Change_o_Des : '-'}}</td>
          <td>{{item.score}}</td>
          <td>{{item.Assist_Qty}}</td>
          <td>{{item.Fo_Qty}}</td>
          <td>{{item.Fs_Qty}}</td>
          <td>{{item.St_Qty}}</td>
          <td>{{item.St_Valid_Qty}}</td>
          <td>{{item.Os_Qty}}</td>
          <td>{{item.Warn_Qty}}</td>
          <td>{{item.Exit_Qty}}</td>
          <td>{{item.loss_Point}}</td>
        </tr>
        </tbody>
        <tbody v-else>
        <tr>
          <td colspan="15" class="noData">해당 경기의 선수 기록이 없습니다.</td>
        </tr>
        </tbody>
      </table>
    </div>
    <MatchNotFound v-else :title="'경기 기록'" style="margin-top: 0" />
  </div>
</template>

<script>
import MatchNotFound from '@/components/Ticket/MatchNotFound.vue';

export default {
  name: 'MatchPlayerRecord',
  components: {MatchNotFound},
  data() {
    return {
      headList: [
        '배번', '이름', '위치', '교체 IN', '교체 OUT', '득점',
        '도움', 'FC', 'FS', '슈팅', '유효', 'OS', '경고',  '퇴장', '실점',
      ],
      recordList: []
    }
  },
  created () {
    const detailId = this.$route.params.id.split('_');
    this.meetYear = detailId[0];
    this.meetSeq = detailId[1];
    this.gameId = detailId[2];
    this.getRecordList();
  },
  mounted() {
    this.$nextTick(() => {
      this.updateStickyPosition();
      window.addEventListener('resize', this.updateStickyPosition);
    });
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.updateStickyPosition);
  },
  methods: {
    updateStickyPosition() {
      this.$nextTick(() => {
        const stickyColumns = this.$refs.sticky;
        if (Array.isArray(stickyColumns)) {
          let leftOffset = 0;

          stickyColumns.forEach((column, index) => {
            if (index === 0) {
              column.style.left = leftOffset + 'px';
            } else {
              leftOffset += column.previousElementSibling.offsetWidth;
              column.style.left = leftOffset + 'px';
            }
          });
        }

        // point 클래스 처리
        const pointColumns = this.$el.querySelectorAll('td.point');
        if (pointColumns.length > 0) {
          let leftOffset = 0;

          pointColumns.forEach((column, index) => {
            column.style.left = leftOffset + 'px';
            leftOffset += column.offsetWidth;
          });
        }

        // thead th 처리
        const stickyHeaders = this.$el.querySelectorAll('th.sticky');
        if (stickyHeaders.length > 0) {
          let leftOffset = 0;

          stickyHeaders.forEach((header, index) => {
            header.style.left = leftOffset + 'px';
            leftOffset += header.offsetWidth;
          });
        }
      });
    },
    async getRecordList() {
      let apiUrl = `/player_record?year=${this.meetYear}&seq=${this.meetSeq}&game_id=${this.gameId}`;
      if(this.meetYear < 2013) {
        apiUrl = '/past_game' + apiUrl;
      } else {
        apiUrl = '/game' + apiUrl;
      }
      const {data} = await this.$http.get(apiUrl);
      if(data.success) {
        if(this.meetYear >= 2013) {
          this.recordList = data.data;
        } else {
          this.recordList = data.data.game;
        }

        this.recordList.map(item => {
          if(this.meetYear >= 2013) {
            item.score = `${item.Goal_B_Qty}/${item.Goal_a_Qty}`;
          } else {
            item.score = item.Goal_B_Qty ? item.Goal_B_Qty : 0;
          }

          item.player_img = `https://www.dragons.co.kr/${item.player_img}`;
        });
      }
    }
  }
}
</script>

<style scoped>
td.point, td.left.sticky, th.sticky {
  position: -webkit-sticky; /* For Safari */
  position: sticky;
  z-index: 1;
  white-space: nowrap; /* 텍스트 줄바꿈 방지 */
}
td.point {
  left: 0; /* 기본적으로 고정 위치 설정 */
}
td.left.sticky, th.sticky:nth-child(2) {
  left: 69px; /* 배번 열의 너비에 따라 조정 */
}
th.sticky:nth-child(1) {
  left: 0; /* 배번 열 위치 조정 */
}
th.sticky:nth-child(2) {
  left: 50px; /* 이름 열 위치 조정 */
}
</style>
